<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Pop up insurance" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <div class="container-wrap">
        <DatePickerRange
          ref="datePickerRange"
          :error="errors.datePicker"
          :disable-dates="disabledDates"
          :start-date="form.startDate"
          :end-date="form.endDate"
          @selected="handleSelected"
          @selectedEnd="e => form.endDate = e"
          @selectedStart="e => form.startDate = e"
          @selectedDisabled="handleSelectedDisabled"
          @selecting="e => dateToSelect = e"
        />
        <h3 class="mt-6">£5m limit for public and products liability</h3>
        <p class="mt-0">This covers your liability to members of the public for bodily injury or damage to their property.</p>

        <h3>£10k contents cover is included</h3>
        <p>Protects your property against theft, loss or damage.</p>
      </div>
    </ProductConfig>
  </div>
</template>

<script>
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import DatePickerRange from '@/components/DatePickerRange.vue'
import rateMixin from '@/mixins/rate'

export default {
  components: {
    ProductCard,
    ProductConfig,
    DatePickerRange,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser) return {}

    const defaultRatingInputs = {
      id: 'CommercialCombined',
      key: 'CommercialCombined\\AppearHere',
      active: true,
      startDate: null,
      endDate: null,
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    return {
      productKey: 'CommercialCombined',
      loading: false,
      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('CommercialCombined').id,
        industryId: this.$store.getters.getIndustryId,
        employeeCount: this.$store.getters.getEmployeeCount,
        postcode: this.$store.getters.getPremises[0].postcode,
      },
      errors: {
        datePicker: false,
      },
      dateToSelect: null,
    }
  },
  computed: {
    disabledDates () {
      // must start date within the next 30 days
      let fromDate = new Date(Date.now() + 86400000 * 29)

      if (this.dateToSelect === 'end' && this.form.startDate) {
        // max policy length is 12 months
        const start = new Date(Number(this.form.startDate))
        start.setDate(this.form.startDate.getDate() + 365)
        fromDate = start
      }

      return {
        to: new Date(new Date().setHours(23, 59, 59) - 86400000),
        from: fromDate,
      }
    },
  },
  created () {
    if (!this.teaser) {
      // Convert prepopulated String to Date
      if (this.form.startDate) { this.form.startDate = new Date(this.form.startDate) }
      if (this.form.endDate) { this.form.endDate = new Date(this.form.endDate) }

      if (this.form.startDate && this.form.endDate) this.dateToSelect = 'end'
    }
  },
  methods: {
    handleSelected (e) {
      this.errors.datePicker = null
      if (this.form.startDate && this.form.endDate) {
        this.handleSubmit()
      }
    },
    handleSelectedDisabled (e) {
      this.errors.datePicker = null
      if (this.dateToSelect === 'start') this.errors.datePicker = 'Start date must be within the next 30 days'
      if (this.dateToSelect === 'end') this.errors.datePicker = 'Maximum policy length is 12 months'
    },
    handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      this.$store.commit('updateEffectiveDate', this.form.startDate)

      this.loading = true

      this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
  },
}
</script>

<style scoped>
h3 {
  @apply text-base font-bold mb-0 block
}
</style>
